import React from "react";
import axios from "axios";
import { AuthSessionManager } from "@homesusa/auth";
import { AppContext } from "@homesusa/layout";
import { impersonateUser } from "core/services/user.service";

const REAUTH_MARKER = "reauth=1";

export const getImpersonationErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === "string" && data.length > 0) {
      return data;
    }
  }

  return "The impersonation request failed";
};

export const addReauthMarker = (redirectUrl: string): string => {
  if (!redirectUrl) {
    return redirectUrl;
  }

  const hashIndex = redirectUrl.indexOf("#");
  const baseUrl = hashIndex === -1 ? redirectUrl : redirectUrl.slice(0, hashIndex);
  const fragment = hashIndex === -1 ? "" : redirectUrl.slice(hashIndex);
  const separator = baseUrl.includes("?") ? "&" : "?";
  return `${baseUrl}${separator}${REAUTH_MARKER}${fragment}`;
};

export const useImpersonateUser = (): ((userId: string) => Promise<void>) => {
  const { addAlert } = React.useContext(AppContext);

  const onImpersonate = async (userId: string): Promise<void> => {
    return impersonateUser(userId)
      .then(({ redirectUrl }) => {
        AuthSessionManager.deleteCookie();
        const destinationUrl = addReauthMarker(redirectUrl);
        if (destinationUrl) {
          window.location.href = destinationUrl;
        } else {
          throw new Error("No destination url was returned");
        }
      })
      .catch((error: unknown) => {
        addAlert({
          message: getImpersonationErrorMessage(error),
          variant: "error"
        });
      });
  };

  return onImpersonate;
};
